// This import loads the firebase namespace along with all its type information.
import MediaStatistic from './media-statistic-model'

export async function load_mediaStatistics(): Promise<MediaStatistic[]> {
  throw 'Not implemented'
}

export async function delete_mediaStatistic(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediaStatistic(): Promise<MediaStatistic> {
  throw 'Not implemented'
}
